import { logUsage } from 'owa-analytics';

import { setMasterPublished } from '../actions/setMasterPublished';
import checkBookingPageStatus from '../selectors/checkBookingPageStatus';
import getEntryPoint from '../selectors/getEntryPoint';
import getFirstTimeUser from '../selectors/getFirstTimeUser';
import getMailboxPuid from '../selectors/getMailboxPuid';
import checkBookingPageIsPublished from './checkBookingPagePublished';
import { getUserMailboxGuid } from './getMailboxGuid';
import setPublishedStatus from './setPublishedStatus';
import { type BookingsRoute } from 'bookingsv2-constants/lib/bookingsRouteConstants';
import { getBookingsRouterStore } from 'bookings-router-store-v2/lib/store';

export default function onPublishBookingPageToggleClicked() {
    const checkStatus = checkBookingPageStatus();
    const published = checkStatus;
    setPublishedStatus(!checkStatus);
    setMasterPublished(!checkStatus);

    if (!published && getFirstTimeUser()) {
        checkBookingPageIsPublished();
    }
    const currentRoute = getBookingsRouterStore().currentRoute;
    logUsage('onBookingPagePublishBtnClick', {
        entryPoint: getEntryPoint(),
        isNewUser: getFirstTimeUser(),
        publish: !checkStatus,
        mailboxGuid: getUserMailboxGuid(),
        bookingMailboxPuid: getMailboxPuid(),
        isUnified: currentRoute === 'homepage' /* Custom data for Unified bookings */,
    });
}
